import type { EntityListSort } from '@/hooks/use-entity-list-sort';
import { Sort } from '@mui/icons-material';
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
export function EntityListSortMenu({ value, onChange }: { value: EntityListSort; onChange: (value: EntityListSort) => void }) {
    const { t } = useTranslation();
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);
    return (<>
        <Tooltip title={t('entity_list.sort.order')}>
            <IconButton onClick={e => setAnchor(e.currentTarget)}>
                <Sort fontSize="small" />
            </IconButton>
        </Tooltip>
        <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
            <MenuItem selected={value === 'updatedAt'} onClick={() => { onChange('updatedAt'); setAnchor(null) }}>
                {t('entity_list.sort.updated')}
            </MenuItem>
            <MenuItem selected={value === 'name'} onClick={() => {
                onChange('name');
                setAnchor(null)
            }}>
                {t('entity_list.sort.name')}
            </MenuItem>
        </Menu>
    </>)
}